host.actions.register({
    // #region Vars
    name: '288a.workbox.document.show',
    // #endregion
    // #region Entry
    async execute(data, params) {
        if (!params?.contextId) {
            return { isSucceeded: false };
        }
        if (!params?.itemId) {
            return { isSucceeded: false };
        }
        //Run
        await this.$host.notification.showModal2(this.$host.components.getComponent("g-prototyp-page__modal"), params, { variant: "slide", position: "bottom", size: "large" });
        //Finish
        return { isSucceeded: false };
    },
    // #endregion
});
export {};
